import { Permission } from './permission.model';


export class Role {
  constructor(
    public name: string,
    public organizationId: string,
    public permissions: string[] = [],
    public published: boolean,
    public editable: boolean,
    public isEditingRole: boolean = false,
    public hasChanges: boolean = false,
    public id?: string
  ) { }

  public static createEmptyRole(): Role {
    return new Role('', undefined, [], false, false, true, false , undefined);
  }
}

export interface RoleForm extends Role {
  admin: boolean;
  published: boolean;
  roleBranch: string;
}
